<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.type}`"
        :data-type="context.type">
        <GmapMap
            ref="gmap"
            v-bind="context.attributes"
            :center="markerPosition"
            :map-type-id="visual.mapTypeId"
            :options="settings.options"
            :style="'height:' + visual.height + 'px'"
            :zoom="visual.zoom"
            class="w-100">
            <GmapMarker
                :clickable="true"
                :draggable="true"
                :position="markerPosition"
                @dragend="updateMarkerCoordinates"
            />
        </GmapMap>
        <div class="d-flex justify-content-end mt-3 position-absolute btn-position-wrapper">
            <button type="button" class="btn btn-success btn-sm" @click="getPosition"><i class="fad fa-map-marker-alt"></i> Standort berechnen</button>
        </div>
    </div>
</template>

<script>
import {gmapApi} from 'gmap-vue';

export default {
    name: 'FormulateMap',
    props: {
        context: {
            model: null,
            type: Object,
            required: true,
        },
        address: Object,
        settings: Object,
        visual: Object,
    },
    data() {
        return {
            markerPosition: {},
        };
    },

    mounted() {
        this.markerPosition = {
            lat: parseFloat(this.settings.location.latitude),
            lng: parseFloat(this.settings.location.longitude),
        };
    },

    methods: {
        getPosition() {
            const geocoder = new this.google.maps.Geocoder();
            let address = this.address.street + ' ' + this.address.zip + ' ' + this.address.city;

            address = address.replace(/\s/g, '+');

            geocoder.geocode({'address': address}, (results, status) => {
                if (status === 'OK') {
                    this.$refs.gmap.$mapPromise.then((map) => {
                        map.setCenter(results[0].geometry.location);
                    });
                    this.markerPosition = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng(),
                    };
                    this.context.model = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng(),
                    };
                } else {
                    alert('Geocode was not successful for the following reason: ' + status);
                }
            });
        },

        updateMarkerCoordinates(location) {
            this.context.model = {
                lat: location.latLng.lat(),
                lng: location.latLng.lng(),
            };
        },
    },

    computed: {
        model() {
            return this.context.model;
        },
        google: gmapApi,
    },
};
</script>

<style>
    .btn-position-wrapper {
        top: 0;
        right: 1rem;
    }
</style>
